import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Icon, IconButton, makeStyles } from '@material-ui/core'

import Menus from 'app/componentV4/Menu/Menus'

const useStyles = makeStyles({
  root: {
    '& .MuiPaper-root': {
      padding: 0,
      maxHeight: '178px',
      overflow: 'auto',
      borderRadius: '4px',
      '& .MuiList-padding': {
        padding: '0',
      },
      '& .MuiMenu-list': {
        padding: '0',
      },
      '& .MuiMenuItem-root': {
        padding: '10px',
      },
    },
  },
})

function MoreVertMenu(props) {
  const {
    children,
    open = () => {},
    disabled = false,
    icon = 'more_vert',
    className = 'p-0 text-neutrals-950',
  } = props
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)

  function openMenu(event) {
    setAnchorEl(event.currentTarget)
    open(true)
  }

  function closeMenu() {
    setAnchorEl(null)
    open(false)
  }

  return (
    <>
      <IconButton
        className={className}
        aria-owns={anchorEl ? 'selectMenu' : null}
        aria-haspopup="true"
        onClick={openMenu}
        fontSize="small"
        disabled={disabled}
      >
        <Icon>{icon}</Icon>
      </IconButton>
      <Menus
        id="selectMenu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
        className={classes.root}
      >
        {children(closeMenu)}
      </Menus>
    </>
  )
}
MoreVertMenu.propTypes = {
  open: PropTypes.func,
  icon: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.func,
  className: PropTypes.string,
}

export default MoreVertMenu
